export default "__VITE_ASSET__CPbluV7W__"